import e from "../../utils/classNames.js";
import t from "../clearableInput/ClearableInput.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
//#region src/components/table/TableSearch.tsx
var i = (i) => {
	let { className: a, ...o } = i;
	return /* @__PURE__ */ r("div", {
		className: e("table-toolbar-search", "input-group", a),
		children: [/* @__PURE__ */ n("span", {
			className: "input-group-addon",
			children: /* @__PURE__ */ n("span", { className: "uikit-icon icon-search" })
		}), /* @__PURE__ */ n(t, { ...o })]
	});
};
//#endregion
export { i as default };

//# sourceMappingURL=TableSearch.js.map